function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "11",
  height: "24",
  viewBox: "0 0 11 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M10.66 0H7.17C3.74 0 1 2.72 1 8c0 3.17 1.24 5.5 3.75 6.66L.06 23.49c-.15.29 0 .51.25.51h2.17c.19 0 .3-.06.37-.22L7.25 15H8.5v8.78c0 .1.08.22.2.22h2.06c.18 0 .24-.1.24-.25V.32c0-.22-.12-.32-.34-.32zM8.5 13H7c-1.5 0-3.5-1.16-3.5-5 0-4 1.63-6 3.5-6h1.5v11z",
  fill: "#fff"
})));